import React from 'react';
import upload from "../../../assets/img/common/upload-two.svg";
import NoteCard from '../../Atom/Cards/NoteCard';


const UploadSuccessfulModal = ({
    redirectToDETCodePage,
    eventId
}) => {
    return (
        <div className='text-center'>
            <img
                src={upload}
                className="mb-3"
                style={{
                    width: "4rem"
                }}
            />
            <p className='label'>
                The upload of DET Codes has been initiated. <br />
                {redirectToDETCodePage ? <>You can check the upload status <a href={`e/${eventId}/det-codes-upload`}> here.</a></>
                    : <>You can check the upload status shortly.</>}
            </p>
            <div className='mt-4'>
                <NoteCard
                    title={"Note: "}
                    text={
                        <>
                            DET Codes will be assigned automatically <br /> to new and existing unassigned attendees
                        </>
                    }
                />
            </div>
            <style jsx>{`
                .det-upload-code-date{
                    padding: 20px 20px;
                    border: 1px solid #E2E2E2;
                    border-radius: 5px;
                    background: #F8F8F8;
                }

                .note-det-code-text{
                    font-family: Hind;
                    font-size: 15px;
                    font-weight: 400;
                    line-height: 24.02px;
                    color: #6D7780;
                }
             `}</style>
        </div>
    )
}

export default UploadSuccessfulModal